import styled from 'styled-components';
import {header} from '../../../component/rightHeader/RightHeader.css';
import {tableContainer} from '../../../component/newTable/Table.css';
import {mobileMedia, tabletMedia} from '../../../globalVariables/GlobalVariables';

export const wrapper=styled.div`
     height: calc(100% - 280px);
     ${header}{
          display:none;
     }
     ${tableContainer}{
          height: calc(100% - 5px);
          margin-top: 5px;
        ${mobileMedia}{
            width: calc(100% - 30px);
            margin: auto;
        }
     }
     ${tabletMedia}{
          height: calc(100% - 156px);
     }
`;

